// userService.js
import { getFirestore, doc, setDoc } from 'firebase/firestore';
import { getFirebaseApp } from './firebaseConfig';

const db = getFirestore(getFirebaseApp());

/**
 * usersコレクションにユーザー情報を保存
 * @param {Object} user - { uid, email, displayName, photoURL }
 */
export async function saveUserToFirestore(user) {
  if (!user?.uid) return;
  await setDoc(doc(db, 'users', user.uid), {
    uid: user.uid,
    email: user.email || '',
    displayName: user.displayName || '',
    photoURL: user.photoURL || '',
    updatedAt: new Date()
  }, { merge: true });
}
